import { ModelBase } from 'store/model-base';

export class CmsCountryCodingMapping extends ModelBase {
    public static storeName: string = 'cmsCountryCodingMapping';

    public gtpCountryCodes: CountryCode;
}
